/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

/**
 * 
 */
export class HealthApi extends runtime.BaseAPI {

    /**
     * Health check endpoint for monitoring and load balancers. Returns 200 if all services are healthy, 503 if any service is unavailable.  This endpoint does not require authentication and can be used by: - Load balancers for health checks - Monitoring systems - Deployment scripts
     */
    async healthRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/health/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Health check endpoint for monitoring and load balancers. Returns 200 if all services are healthy, 503 if any service is unavailable.  This endpoint does not require authentication and can be used by: - Load balancers for health checks - Monitoring systems - Deployment scripts
     */
    async healthRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.healthRetrieveRaw(initOverrides);
    }

}
